import React, { FC } from 'react';

import { Modal } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

import { NotificationsForm } from './NotificationsForm';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const NotificationsModal: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslate();

  return (
    <Modal
      open={open}
      onClose={onClose}
      modalHeaderProps={{
        title: t('settings.notifications'),
        message: t('settings.quicklyEditYourNotificationPreferencesHere'),
        className: 'mb-4',
        onClose,
      }}
    >
      <NotificationsForm resetButtonPlacement="bottom" compact onResetSubmit={onClose} />
    </Modal>
  );
};
